import i18n from '../i18n'

export const attachments = [
    {
        name: i18n.t('customWorkflow:attachments.1.name'),
        date: i18n.t('customWorkflow:attachments.1.date'),
        user: i18n.t('customWorkflow:attachments.1.user')
    },
    {
        name: i18n.t('customWorkflow:attachments.2.name'),
        date: i18n.t('customWorkflow:attachments.2.date'),
        user: i18n.t('customWorkflow:attachments.2.user')
    },
]

export const tooltipTexts = {
    change: i18n.t('customWorkflow:tooltips.change'),
    complete: i18n.t('customWorkflow:tooltips.complete'),
    done: i18n.t('customWorkflow:tooltips.done'),
    doneInstance: i18n.t('customWorkflow:tooltips.doneInstance')
}

export const description = {
    __html: i18n.t('customWorkflow:text')
}

export const categories = [
    {
        id: 1,
        name: i18n.t('customWorkflow:categories.marketing')
    },

    {
        id: 2,
        name: i18n.t('customWorkflow:categories.dev')
    },

    {
        id: 3,
        name: i18n.t('customWorkflow:categories.admin')
    }
]

export const statuses = [
    {   id: 1,
        name: i18n.t('customWorkflow:statuses.notStarted'),
        color: '79, 103, 194',
        category: 1
    },

    {
        id: 2,
        name: i18n.t('customWorkflow:statuses.inProgress'),
        color: '36, 168, 246',
        category: 1
    },

    {   id: 3,
        name: i18n.t('customWorkflow:statuses.pendingApproval'),
        color: '0, 199, 220',
        category: 1
    },
    
    {   id: 4,
        name: i18n.t('customWorkflow:statuses.completed'),
        color: '155, 202, 92',
        isComplete: true,
        category: 1
    },

    {   id: 5,
        name: i18n.t('customWorkflow:statuses.approved'),
        color: '0, 164, 154',
        category: 1
    },

    {   id: 6,
        name: i18n.t('customWorkflow:statuses.onHold'),
        color: '131, 98, 200',
        category: 1
    },

    {   id: 7,
        name: i18n.t('customWorkflow:statuses.cancelled'),
        color: '180, 179, 180',
        category: 1
    },

    {
        id: 8,
        name: i18n.t('customWorkflow:statuses.inDesign'),
        color: '180, 179, 180',
        category: 2
    },

    {
        id: 9,
        name: i18n.t('customWorkflow:statuses.readyForDev'),
        color: '36, 168, 246',
        category: 2
    },

    {
        id: 10,
        name: i18n.t('customWorkflow:statuses.inDev'),
        color: '0, 199, 220',
        category: 2
    },

    {
        id: 11,
        name: i18n.t('customWorkflow:statuses.codeReview'),
        color: '255, 238, 88',
        category: 2
    },

    {
        id: 12,
        name: i18n.t('customWorkflow:statuses.inQA'),
        color: '0, 164, 154',
        category: 2
    },

    {
        id: 13,
        name: i18n.t('customWorkflow:statuses.completed'),
        color: '131, 98, 200',
        category: 2
    },

    {
        id: 14,
        name: i18n.t('customWorkflow:statuses.released'),
        color: '155, 202, 92',
        isComplete: true,
        category: 2
    },

    {
        id: 15,
        name: i18n.t('customWorkflow:statuses.forApproval'),
        color: '180, 179, 180',
        category: 3
    },

    {
        id: 16,
        name: i18n.t('customWorkflow:statuses.inProgress'),
        color: '36, 168, 246',
        category: 3
    },

    {
        id: 17,
        name: i18n.t('customWorkflow:statuses.approved'),
        color: '0, 199, 220',
        category: 3
    },

    {
        id: 18,
        name: i18n.t('customWorkflow:statuses.inTheTrip'),
        color: '255, 238, 88',
        category: 3
    },

    {
        id: 19,
        name: i18n.t('customWorkflow:statuses.travelReport'),
        color: '0, 164, 154',
        category: 3
    },

    {
        id: 20,
        name: i18n.t('customWorkflow:statuses.completed'),
        color: '155, 202, 92',
        isComplete: true,
        category: 3
    },

    {
        id: 21,
        name: i18n.t('customWorkflow:statuses.cancelled'),
        color: '131, 98, 200',
        category: 3
    },
]

export const defaultStatus = 1